export const TIPOS = [
  { id: 1, value: 'NFSE' },
  { id: 2, value: 'BOLETO' },
  { id: 3, value: 'NFSE NACIONAL' },
  { id: 4, value: 'REMESSA FINANCEIRA' },
]

export const FORMATOS = [
  { id: 1, value: 'XML' },
  { id: 2, value: 'JSON' },
]

export const OPTIONS_FILTER_TIPO = [
  { label: 'TODOS', value: '' },
  { label: 'NFSE', value: 1 },
  { label: 'BOLETO', value: 2 },
  { label: 'NFSE NACIONAL', value: 3 },
  { label: 'REMESSA FINANCEIRA', value: 4 },
]

export const OPTIONS_FILTER_FORMATO = [
  { label: 'TODOS', value: '' },
  { label: 'XML', value: 1 },
  { label: 'JSON', value: 2 },
]
